<template>
    <div class="padTop CardContainerComponent">
        <div class="cardwithlink">
            <div class="card cardwithlink default vuecard">
                <!-- <a :href="link"> -->
                    <a :href="'/parks/allparks/?ID=' + id">
                    <div class="content">
                        <div class="topSection" style="height: 130px;">
                            <div class="cardTitle">{{ parkname }}
                            </div>
                            <div class="cardExcerpt">
                                <p>
                                    {{ desc }}
                                </p>
                            </div>
                        </div>
                        <div class="btmleft">
                            <i class="fa fa-map-marker"></i><span class="calendartext">{{ parkaddress }}</span>
                        </div>
                    </div>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
// Hima, Do this one

export default {
  name: "Card",
  props: {
    parkname: String,            
    parkaddress: String,
    id: Number,
    link: String,
    desc: String,
  },
};
</script>
<style scoped lang="scss">
    /* css for trimming multi-line text on the card Title and Excerpt*/
    #parklist-actions {
        .CardContainerComponent {
            margin-top: 30px !important;
            .cardwithlink {
                .content {
                    .cardExcerpt p {
                        display: -webkit-box;
                        color: #000 !important;
                        -webkit-line-clamp: 3;
                        -webkit-box-orient: vertical;
                        overflow: hidden;
                    }

                    .cardTitle {
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                        overflow: hidden;
                        font-size: 18px;
                        text-transform: capitalize;

                        &:hover {
                            text-decoration: underline;
                        }
                    }
                    .btmleft .calendartext{
                        margin-left:10px;
                        width: 260px;
                    }
                }
            }
            .cardwithlink {        
                .vuecard{
                    min-height: 212px;
                    margin: 0 5px;

                    a {
                        text-decoration: none !important;
                        color: #333!important;
                    }
                }    
            }
            .card.cardwithlink {
                background: #fff;
                margin-top: 5px !important;
                margin-bottom: 5px !important;
                display: block;
                float: left;
                border: #f1f1f1 1px solid;
                box-shadow: 0px 1px 2px 0px #f1f1f1;
                padding: 0px;
                .content {
                    padding: 20px 10px 20px 15px;
                    font-size: 16px;
                    font-family: "Open Sans";
                    width: 310px;
                    font-style: normal;
                }
                .cardTitle {
                    font-weight: bold;
                    padding: 1px 0;
                }
                .cardExcerpt {
                    padding-top: 12px;
                }
                .calendartext {
                    font-size: 12px;
                    float: left;
                    margin-top: 2px;
                    font-weight: normal !important;
                }
                .btmleft svg {
                    float: left;;
                }
            }




        } //end of CardContainerComponent

    }

</style>
